import { RerunReasonType } from "./enums";

export class RerunTestTrackingRequest {
    OrderId: number;
    SpecimenNo: number;
    SpecimenTransactionId: number;
    AnalyzerId: number;
    Reason: RerunReasonType;
    OtherReasonText: string;
    Comment: string;
}
